module.exports = __webpack_public_path__ + "static/media/flag08.cb49952b.svg";